// Infinite Scroll pagination using IntersectionObserver for Shopify Collections

document.addEventListener('DOMContentLoaded', () => {
  initInfiniteScroll();
});

function initInfiniteScroll() {
  const grid = document.getElementById('infinite-scroll-grid');
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  
  if (!grid || !sentinel) return;

  let isLoading = false;

  const observerOptions = {
    root: null, // viewport
    rootMargin: '200px 0px', // trigger fetch early before user reaches the bottom
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !isLoading) {
        const nextUrl = grid.getAttribute('data-next-page');
        if (nextUrl) {
          loadNextPage(nextUrl);
        } else {
          // No more pages, stop observing
          observerInstance.unobserve(sentinel);
          sentinel.classList.add('hidden');
        }
      }
    });
  }, observerOptions);

  // Start observing the loading spinner sentinel
  observer.observe(sentinel);

  function loadNextPage(url) {
    isLoading = true;
    sentinel.classList.remove('hidden');

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Sonsuz sayfa yüklenemedi.');
        }
        return response.text();
      })
      .then(htmlString => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        
        const newGrid = doc.getElementById('infinite-scroll-grid');
        const newProducts = newGrid ? newGrid.children : [];
        
        // Append new products to the current grid
        if (newProducts.length > 0) {
          // Convert HTMLCollection to array and append
          Array.from(newProducts).forEach(card => {
            grid.appendChild(card);
          });
        }
        
        // Update next page URL
        const newNextUrl = newGrid ? newGrid.getAttribute('data-next-page') : null;
        if (newNextUrl) {
          grid.setAttribute('data-next-page', newNextUrl);
        } else {
          grid.removeAttribute('data-next-page');
          observer.unobserve(sentinel);
          sentinel.classList.add('hidden');
        }
      })
      .catch(error => {
        console.error('Error fetching collection next page:', error);
      })
      .finally(() => {
        isLoading = false;
      });
  }
}
